export enum EntitesPath {
  ROOT = '',
  EDITION = 'edition-entite',
  CREATION = 'creation-entite',
  ID_ENTITE_PARAM = 'idEntite',
}
